import COMMON from "common";
import pathnames from "routes/pathnames";
import AppLayout from "components/app-layout";
import { publicRoutes, protectedRoutes } from "common/auth-routes";

import Page404 from "pages/page-404";
import PageApp from "pages/page-app";
import PageLogin from "pages/page-login";
import PageProfile from "pages/page-profile";
import PageDashboard from "pages/page-dashboard";
import PageMaintenance from "pages/page-maintenance";
import PageLeaves from "pages/leave-management/page-leaves";
import PageLeavesHistory from "pages/leave-management/page-leaves-history";
import PageLeavesSummary from "pages/leave-management/page-leaves-summary";
import PageLeavesPending from "pages/leave-management/page-leaves-pending";
import PageLeavesUpcoming from "pages/leave-management/page-leaves-upcoming";
import PageLeaveRequests from "pages/leave-management/page-leave-requests";
import PageLeavesDirectory from "pages/leave-management/page-leaves-directory";
import PageLeavesOverview from "pages/leave-management/page-leaves-overview";
import PageOvertimePending from "pages/overtime-management/page-overtime-pending";
import PageOvertimeHistory from "pages/overtime-management/page-overtime-history";
import PageOvertimeRequests from "pages/overtime-management/page-overtime-requests";
import PageOvertimeTeamHistory from "pages/overtime-management/page-overtime-team-history";
import PageClaimSummary from "pages/claim-management/page-claim-summary";
import PageClaimHistory from "pages/claim-management/page-claim-history";
import PageClaimPending from "pages/claim-management/page-claim-pending";
import PageSignup from "pages/page-signup";
import PageCreatePassword from "pages/page-create-password";
import PageAppointment from "pages/appointment/page-appointment";
import PageUpcoming from "pages/appointment/page-upcoming";
import PageResetPassword from "pages/forgot-password/page-reset-password";
import PageVerifyEmail from "pages/forgot-password/page-verify-email";
import PageOngoingAssignments from "pages/e-learning/page-ongoing-assignments";
import PageAssignments from "pages/e-learning/page-assignments";
import PageCertificates from "pages/e-learning/page-certificates";

const token = localStorage.getItem(COMMON.AUTH_TOKEN) || sessionStorage.getItem(COMMON.AUTH_TOKEN);

const routes = [
	{ path: pathnames.login, element: <PageLogin />, authenticated: false },
	{ path: pathnames.dashboard, element: <PageDashboard />, authenticated: true },
	{ path: pathnames.profile, element: <PageProfile />, authenticated: true },
	{ path: pathnames.leaves, element: <PageLeaves />, authenticated: true },
	{ path: pathnames.leavesUpcoming, element: <PageLeavesUpcoming />, authenticated: true },
	{ path: pathnames.leavesHistory, element: <PageLeavesHistory />, authenticated: true },
	{ path: pathnames.leavesSummary, element: <PageLeavesSummary />, authenticated: true },
	{ path: pathnames.leavesPending, element: <PageLeavesPending />, authenticated: true },
	{ path: pathnames.leaveRequests, element: <PageLeaveRequests />, authenticated: true },
	{ path: pathnames.leavesDirectory, element: <PageLeavesDirectory />, authenticated: true },
	{ path: pathnames.leavesOverview + "/:id", element: <PageLeavesOverview />, authenticated: true },
	{ path: pathnames.overtimePending, element: <PageOvertimePending />, authenticated: true },
	{ path: pathnames.overtimeHistory, element: <PageOvertimeHistory />, authenticated: true },
	{ path: pathnames.overtimeRequests, element: <PageOvertimeRequests />, authenticated: true },
	{ path: pathnames.overtimeTeamHistory, element: <PageOvertimeTeamHistory />, authenticated: true },
	{ path: pathnames.claimSummary, element: <PageClaimSummary />, authenticated: true },
	{ path: pathnames.claimHistory, element: <PageClaimHistory />, authenticated: true },
	{ path: pathnames.claimPending, element: <PageClaimPending />, authenticated: true },
	{ path: pathnames.ongoingAssigment, element: <PageOngoingAssignments />, authenticated: true },
	{ path: pathnames.assignment, element: <PageAssignments />, authenticated: true },
	{ path: pathnames.certificate, element: <PageCertificates />, authenticated: true },
	{ path: pathnames.app, element: <PageApp />, authenticated: false },
	{ path: pathnames.maintenance, element: <PageMaintenance />, authenticated: false },
	{ path: pathnames.signUp, element: <PageSignup />, authenticated: false },
	{ path: pathnames.createPassword, element: <PageCreatePassword />, authenticated: false },
	{ path: pathnames.pageAppointmentSession, element: <PageAppointment />, authenticated: true },
	{ path: pathnames.pageUpcoming, element: <PageUpcoming />, authenticated: true },
	{ path: pathnames.resetPassword, element: <PageResetPassword />, authenticated: false },
	{ path: pathnames.verifyResetEmail, element: <PageVerifyEmail />, authenticated: false },

	{ path: "*", element: <Page404 />, authenticated: !!token },
];

const enrichedRouters = routes.map(({ authenticated, ...res }) => {
	if (!authenticated) return { ...res, loader: publicRoutes, errorElement: <Page404 /> };

	return { ...res, element: <AppLayout>{res.element}</AppLayout>, loader: protectedRoutes, errorElement: <Page404 /> };
});

export default enrichedRouters;
